import { Alert, AlertTitle } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

type Props = {
  title?: string;
};

export const Info: FC<PropsWithChildren<Props>> = ({ title, children }) => (
  <Alert
    icon={<HelpOutlineIcon sx={{ color: '#900c2b' }} />}
    sx={{
      backgroundColor: '#fff0f4',
      color: '#900c2b',
    }}
  >
    {title && <AlertTitle sx={{ fontWeight: 'bold' }}>{title}</AlertTitle>}
    {children}
  </Alert>
);
